import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tools--table"
export default class extends Controller {
  static targets = ["table"]

  connect() {
    this.resetSelectedEntry();
  }

  resetSelectedEntry() {
    this.tableTarget
      .querySelectorAll('tr')
      .forEach(tr => tr.classList.remove('selected'));
  }

  edit(event) {
    const row = event.currentTarget;
    const url = row.dataset.editUrl;
    Turbo.visit(url, { frame: 'tool-form' });
    this.resetSelectedEntry();
    row.classList.add('selected');
  }
}
